<template>
  <div class="finance_m">
    <div class="authentication-tips" v-if="meansData.needProductAgreement == 1 && level == 1">
      <img class="icon-warning" src="@static/images/authentication/c-warning.png" />
      <p>温馨提示：您有补充产品协议待签署，或已签署的协议处于审核中/审核失败状态，导致部分金额暂无法提现。</p>
      <span @click="openAgreementModal">查看详情<img class="icon-right" src="@static/images/authentication/c-to.png"/></span>
    </div>
    <!-- 未认证、未通过 -->
    <div class="authentication-tips" v-if="(status == 0 || status == 3 || status == 1) && level == 1">
      <img class="icon-warning" src="@static/images/authentication/c-warning.png" alt="" v-if="status == 0 || status == 3" />
      <img class="icon-warning icon-wait" src="@static/images/authentication/w.png" alt="" v-if="status == 1" />
      <p v-if="status == 0 || status == 3">您的账号还未成功认证，暂无法提现。请尽快认证。</p>
      <p v-if="status == 1">您的账户正在认证中，暂时无法提现。请耐心等待审核结果。</p>
      <span @click="$router.push({ name: 'authenticationInformation' })" v-if="status != 1"
        >去认证<img class="icon-right" src="@static/images/authentication/c-to.png"
      /></span>
    </div>
    <div class="incomerule">
      <div class="top-box" v-if="level == 1 || level == 2">
        <div class="income">
          <div class="sr pointer" @click="goWaitList">
            <div class="xl">
              <span class="el-dropdown-link"> 待生效收入 <i class="icon-youjiantou"></i> </span>
            </div>
            <div class="num">{{ meansData.waitValidMoney | fixedNum1 }}元</div>
          </div>
          <div class="sr">
            <div class="xl">
              <span class="el-dropdown-link"> 提现中金额 </span>
            </div>
            <div class="num">{{ meansData.cashingPostal | fixedNum1 }}元</div>
          </div>
          <div class="sr">
            <div class="xl">
              <span class="el-dropdown-link"> 可提现金额 </span>
            </div>
            <div class="num">{{ meansData.validCashPostal | fixedNum1 }}元</div>
          </div>
          <div class="cz">
            <div class="checkbox" v-if="mechanUserType == 2 || mechanUserType == 3">
              <span @click="changeradio"><img src="@static/images/gou.png" v-show="radio" alt=""/></span>
              <i>我已阅读、理解、并同意<u @click="xyflage">《共享经济合作伙伴协议》</u></i>
            </div>
            <el-button type="warning" @click="updateMeans()">提现</el-button>
          </div>
        </div>
        <div class="setp-box">
          <div class="step-item">
            <img src="@static/images/finance-step1.png" alt="" />
            <p>申请提现(待上传资料)</p>
            <p>下载结算函及明细</p>
            <div class="line"></div>
          </div>
          <div class="step-item">
            <img src="@static/images/finance-step2.png" alt="" />
            <p>线上申请/线下寄送</p>
            <p>发票和结算函明细</p>
            <div class="line"></div>
          </div>
          <div class="step-item">
            <img src="@static/images/finance-step3.png" alt="" />
            <p>提现中</p>
            <p>财务审核资料并进行打款</p>
            <div class="line"></div>
          </div>
          <div class="step-item">
            <img src="@static/images/finance-step4.png" alt="" />
            <p>提现完成</p>
            <p>转账成功或者转账失败</p>
          </div>
        </div>
      </div>

      <div class="tabtal">
        <div class="block" v-if="activeName2 == 'first'">
          <span class="label">日期</span>
          <el-select v-model="dateType" placeholder="请选择" style="width: 100px">
            <el-option label="按月" value="1"></el-option>
            <el-option label="按年" value="2"></el-option>
          </el-select>
          <el-date-picker type="month" v-model="monthDate" placeholder="选择日期" v-if="dateType == '1'" value-format="yyyy-MM"></el-date-picker>
          <el-date-picker type="year" v-model="yearDate" placeholder="选择日期" v-if="dateType == '2'" value-format="yyyy"></el-date-picker>
          <span class="label">结算类型</span>
          <el-select v-model="type" placeholder="请选择" style="width: 110px" clearable>
            <el-option :label="text" :value="value" v-for="(text, value) in typeMap" :key="value"></el-option>
          </el-select>
          <span class="label" v-if="level == 1">结算主体</span>
          <el-select v-model="subCompanyId" placeholder="请选择" style="width: 270px" clearable v-if="level == 1">
            <el-option v-for="(item, i) in subCompanysList" :key="i" :label="item.subCompanyName" :value="item.subCompanyId"></el-option>
          </el-select>
          <span class="label">提现状态</span>
          <el-select v-model="type2" placeholder="请选择" style="width: 100px">
            <el-option label="全部" value=""></el-option>
            <el-option label="待上传" value="5" v-if="mechanUserType == 1 && level == 1"></el-option>
            <el-option label="申请中" value="2"></el-option>
            <el-option label="审核中" value="4"></el-option>
            <el-option label="已驳回" value="1"></el-option>
            <el-option label="已转账" value="3"></el-option>
          </el-select>
          <el-button type="warning" @click="changeDate()">查询</el-button>
        </div>
        <div class="block" v-if="activeName2 == 'second'">
          <el-select v-model="dateType2" placeholder="请选择" style="width: 120px">
            <el-option label="创建日期" value="1"></el-option>
            <el-option label="发放日期" value="2"></el-option>
          </el-select>
          <el-date-picker
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            style="width: 260px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <span class="label">提现状态</span>
          <el-select v-model="type2" placeholder="请选择" style="width: 100px">
            <el-option label="全部" value=""></el-option>
            <el-option label="待上传" value="5" v-if="mechanUserType == 1 && level == 1"></el-option>
            <el-option label="申请中" value="2"></el-option>
            <el-option label="审核中" value="4"></el-option>
            <el-option label="已驳回" value="1"></el-option>
            <el-option label="已转账" value="3"></el-option>
          </el-select>
          <el-button type="warning" @click="changeDate()">查询</el-button>
        </div>
        <el-tabs class="content" v-model="activeName2" type="border-card" @tab-click="handleClick(1)" v-loading="pageLoading">
          <el-tab-pane label="账单明细" name="first">
            <el-table tooltip-effect="dark" :data="readListData" border stripe class="omtable" style="width: 100%">
              <el-table-column prop="balanceDate" label="结算日期" width="140" min-width="160px" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="cashStatus" label="状态" width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.cashStatus == 5">申请提现 <br />（待上传资料）</span>
                  <span v-else-if="scope.row.cashStatus == 2 || scope.row.cashStatus == 6">申请中</span>
                  <span v-else>{{ all.CASH_STATUS[scope.row.cashStatus] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="结算类型" :show-overflow-tooltip="true" min-width="100px">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 3"
                    >活动<span v-if="scope.row.activityName">-{{ scope.row.activityName }}</span></span
                  >
                  <span v-else>{{ all.BALANCE_TYPE[scope.row.type] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="payNum" label="期数" v-if="curType == 2 || !curType" :show-overflow-tooltip="true" min-width="100px">
                <template slot-scope="scope">
                  <span>{{ scope.row.payNum || '--' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="policyFeeSum" label="总保费（元）" :show-overflow-tooltip="true" min-width="120px"></el-table-column>
              <el-table-column prop="policyNum" label="保单数" :show-overflow-tooltip="true" min-width="100px"></el-table-column>
              <el-table-column prop="policyIncomes" label="应结费用（元）" :show-overflow-tooltip="true" min-width="140px">
                <template slot-scope="scope">
                  <span>{{ scope.row.policyIncomes }}</span>
                  <activityTip v-if="scope.row.activityIncomes * 1" activityName="含无门槛活动奖励" :subsidyIncomes="scope.row.activityIncomes"></activityTip>
                </template>
              </el-table-column>
              <el-table-column prop="incomeTax" label="实际收入（元）" :show-overflow-tooltip="true" min-width="140px"></el-table-column>
              <el-table-column
                prop="subCompanyName"
                label="结算主体"
                :show-overflow-tooltip="true"
                min-width="140px"
                key="subCompanyName"
                v-if="level == 1"
              ></el-table-column>
              <el-table-column label="操作" width="210" fixed="right">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button type="danger" @click="readDetail(scope.row)">结算明细</el-button>
                    <el-button type="warning" @click="jumpWait()" v-if="scope.row.cashStatus == 5">上传提现资料</el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <p class="yjjs" v-if="level == 1">
              <span v-if="Date.now() < new Date('2022/10/1').getTime()">注：应结费用为出单收入；实际收入：扣税后的实际到账收入</span>
              <span v-else
                >注：应结费用为出单收入；实际收入为扣税后的实际到账收入（2022年10月1日0时起企业类合作伙伴出单后，开具税点为3%增值税专用发票的，实际收入=应结费用*0.97；开具税点为1%增值税专用发票的，实际收入=应结费用*0.95；开具增值税普通发票的，实际收入=应结费用*0.94；2022年10月1日0时前已承保的保单对应的首期/续期结算费用，不受该标准的影响）</span
              >
            </p>
            <div class="bls">
              <el-pagination
                :current-page.sync="readCurrent"
                @current-change="readListFun"
                :page-size="10"
                background
                layout="total,prev, pager, next, jumper"
                :total="readtotalPage"
              ></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="提现记录" name="second" v-if="level == 1 || level == 2">
            <el-radio-group v-model="activeName3" style="margin-bottom: 15px" v-if="mechanUserType == 1 && level == 1" @change="handleClick(2)">
              <el-radio-button label="1">待上传发票</el-radio-button>
              <el-radio-button label="2">已发起提现</el-radio-button>
            </el-radio-group>
            <el-table :data="tableData" border class="omtable" tooltip-effect="dark" style="width: 100%" :key="activeName3">
              <el-table-column type="index" prop="date" label="序号" width="80"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime | timeNum(10) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="结算主体" min-width="160px" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ all.SUB_COMPANY_ID[scope.row.subCompanyId] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cashAmount" label="申请金额（元）" min-width="120" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="cashStatus" label="状态" min-width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="scope.row.cashStatus == 2 || scope.row.cashStatus == 6">申请中</span>
                  <span v-else>{{ all.CASH_STATUS[scope.row.cashStatus] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="failMsg" label="备注" min-width="120" :show-overflow-tooltip="true" v-if="activeName3 == 2">
                <template slot-scope="scope">
                  <!-- 转账失败 -->
                  <span v-if="scope.row.cashStatus == 1" style="color: red">{{ scope.row.failMsg }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="410" v-if="activeName3 == 1 || mechanUserType == 1">
                <template slot-scope="scope">
                  <el-button-group v-if="activeName3 == 1">
                    <el-button type="text" @click="$refs.withdrawalDetailModal.open('detail', scope.row)">详情</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">结算函及明细下载</el-button>
                    <el-button type="text" @click="$refs.withdrawalFormByMechan.open(scope.row)">上传发票及结算资料</el-button>
                    <el-button type="text" @click="delWithdraw(scope.row)">撤销</el-button>
                  </el-button-group>
                  <el-button-group v-if="activeName3 == 2 && mechanUserType == 1">
                    <el-button type="text" @click="downloadFile(scope.row)">结算函及明细下载</el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <div class="bls">
              <el-pagination
                :current-page.sync="tabsCurrent"
                @current-change="tabsFun"
                :page-size="10"
                background
                layout="total,prev, pager, next, jumper"
                :total="totalPage"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- 收益明细详情 -->
        <el-dialog width="400px" :visible.sync="successFlage">
          <div class="successFlageTg">
            <img src="@static/images/success1.png" alt="" class="img3" />
            <p class="p1">提现申请提交成功</p>
            <p class="p2">工作人员将在1-5个工作日内处理，节假日顺延</p>
          </div>
        </el-dialog>

      </div>
    </div>
    <div class="incomerule2" v-if="level == 1">
      <div class="rule">
        <div class="item">
          <div class="title">
            平台将按照以下规则对满足条件的保单进行结算 <a style="color: #21a1fe" @click="$refs.settlementExplainHistoryModal.open()">历史结算规则</a>
          </div>
          <div class="title">一、首期结算规则</div>
          <div class="content">
            <p>1、每月18日，结算上月首期已过犹豫期（截止本月17日）且回执回访质检成功保单（法定节假日顺延）；</p>
            <p>2、如有参加活动，每月20日-25日结算上月参加活动，首期已过犹豫期且回执回访质检成功保单对应活动奖励（法定节假日顺延）；</p>
            <p>注：双录单/单录确权单需质检通过</p>
          </div>
          <div class="title">二、续期结算规则</div>
          <div class="content">
            <p>1、所有产品，宽限期后第2个月10日</p>
            <p>例：2025年1月1日-2025年1月31日生效的保单，续期缴费日为2026年1月1日-2026年3月31日，服务费生效（下发）日为2026年5月10日</p>
            <p>2、复效成功保单结算规则</p>
            <p>（1）复效时效要求</p>
            <p>当年度应续费保单，需于次年度3月31日（含）之前完成复效，逾期复效无法结算续期服务费</p>
            <p>示例：2025年度应续保保单，须在2026年3月31日（含）前完成复效。</p>
            <p>（2）复效保单续期服务费结算标准</p>
            <p class="indent">①复效成功保单所在月继续率达到支付续期服务费标准：该复效成功保单按照保单月度对应的继续率发放比例结算，进阶继续率服务费不再进行结算;</p>
            <p class="indent">②复效成功保单所在月继续率未达到支付续期服务费标准，若该复效成功保单计入所在月继续率后：</p>
            <p class="indent2">a.所在月继续率达到支付续期服务费标准的，该复效保单所在月份的所有保单，统一按最低继续率发放比例结算</p>
            <p class="indent2">b.若所在月继续率仍未达到支付标准：该复效成功保单无法结算续期服务费。</p>
          </div>

          <div class="title">结算服务费与开票税点计算规则</div>
          <div class="content">
            <p>（1）开具6%增值税专用发票：结算收入按100%支付，服务费收入不另作扣除。</p>
            <p>（2）开具3%增值税专用发票：结算收入按97%支付，即服务费收入×0.97。</p>
            <p>（3）开具1%增值税专用发票：结算收入按95%支付，即服务费收入×0.95。</p>
            <p>（4）开具增值税普通发票：结算收入按94%支付，即服务费收入×0.94。</p>
          </div>

          <div class="title">提现规则</div>
          <div class="content">
            <p>1、最低提现金额为100元（含），如果累计提现金额未达到100元，无法提交提现申请。</p>
            <p>
              2、<span class="red">服务费结算需满足相关条件</span
              >，在犹豫期内退保则无服务费。首期服务费将每月进行结算，续期服务费需达到具体产品继续率要求才可结算。
            </p>
            <p>
              3、<span class="red">申请提现需提供发票：</span>机构用户需根据申请的发票条目，分别开发票。
              <a style="color: #21a1fe" @click="$refs.invoiceDetailModal.open()">查看开票信息</a>
            </p>
            <p>4、机构用户需提供结算确认函、结算明细表，结算确认函与结算明细表需盖公章（明细表如有多张，需有骑缝公章）并随发票邮寄至我方。</p>
            <p>
              5、每次提交提现申请，将在5-7个工作日左右（节假日顺延）完成支付服务费。企业类用户将在收到发票和结算函的5-7个工作日左右（节假日顺延）完成支付服务费。
            </p>
            <p>6、因银行转账时间的差异，提现收入将在1-3日内到账，若提现申请状态显示“转账完成”，说明凤栖云服已向银行安排付款，银行正在处理，请耐心等待。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 结算规则历史 -->
    <settlement-explain-history-modal ref="settlementExplainHistoryModal" />
    <!-- 提现期数弹窗 -->
    <withdrawal-number-modal ref="withdrawalNumberModal" @submit="$refs.withdrawalDetailModal.open('add', $event)" @uploadAgreement="$refs.agreementListModal.open($event)"/>
    <!-- 提现详情 -->
    <withdrawal-detail-modal
      ref="withdrawalDetailModal"
      @reload="
        checkMeans();
        changeDate();
      "
      @jumpWithdraw="jumpWithdraw"
      @submit="$refs.withdrawalForm.open($event)"
    />
    <!-- 企业提现表单 -->
    <withdrawal-form-by-mechan ref="withdrawalFormByMechan" @reload="reload(true)" @openInvoiceDetail="$refs.invoiceDetailModal.open()" />
    <!-- 个人机构提现表单 -->
    <withdrawal-form ref="withdrawalForm" @reload="reload(true)" />
    <!-- 上传产品补充协议弹窗 -->
    <agreement-list-modal ref="agreementListModal" @submit="handleAgreementSubmit" />
    <!-- 提现期数弹窗 -->
    <invoiceDetailModal ref="invoiceDetailModal" :subCompanysList="subCompanysList" />
  </div>
</template>
<script>
//当前实例组件
import activityTip from '@/components/activityTip';
import withdrawalNumberModal from './component/withdrawalNumberModal';
import withdrawalFormByMechan from './component/withdrawalFormByMechan';
import withdrawalForm from './component/withdrawalForm';
import withdrawalDetailModal from './component/withdrawalDetailModal';
import invoiceDetailModal from './component/invoiceDetailModal';
import settlementExplainHistoryModal from './component/settlementExplainHistoryModal';
import agreementListModal from './component/agreementListModal';
export default {
  data: () => {
    return {
      typeMap: {},
      subCompanyId: '',
      sealImgList: [], //提现盖章图片
      subCompanysList: [], //分公司列表
      level: 1,
      isXbbSecondMechan: 0,
      readtotalPage: 0,
      readCurrent: 1,
      tabsCurrent: 1,
      dialogVisible: false,
      close: false,
      meansData: {}, //财产数据
      activeName2: 'first',
      activeName3: '1',
      dateType: '1', //1按月 2 按年
      policyType: '1', //保单类型
      monthDate: '', //日期
      yearDate: '', //日期
      dateType2: '1', //提现日期类型 1申请日期 2 转账日期
      date: '', //提现查询日期
      type: '', //结算类型
      curType: '', //当前查询的结算类型
      type2: '', //提现类型
      all: { BANK_TYPE: [] },
      pageLoading: false,
      bankLoading: false,
      getcodeflage: true, //获取验证码标记
      getcodetext: '验证码',
      timer: {}, //验证码计时器
      isflageNum: 0, //上传发票的状态
      policy_Status: {},
      cashStatus: '',
      totalPage: 0, //提现记录总分页数
      readListData: [],
      tableData: [],
      successFlage: false, //提现状态
      detailData: '',
      balanceId: '',
      mechanUserType: 1, //客户类型
      isOpenSecond: 0, //是否有二开权限
      radio: true,
      status: '-1'
    };
  },
  components: {
    activityTip,
    withdrawalNumberModal,
    withdrawalDetailModal,
    withdrawalForm,
    withdrawalFormByMechan,
    invoiceDetailModal,
    settlementExplainHistoryModal,
    agreementListModal
  },
  created() {
    this.readCurrent = 1;
    if (this.$route.query.tab1) {
      this.activeName2 = this.$route.query.tab1;
    }
    if (this.$route.query.tab2) {
      this.activeName3 = this.$route.query.tab2;
    }
    const user = this.$tools.getLocal('userinfo');
    this.level = user.level;
    this.isXbbSecondMechan = user.isXbbSecondMechan;
    this.queryMechanInfo();
    this.checkMeans();
    this.changeDate(1);
    this.getCashPostal();
    this.getUserInfo();
    this.getSubCompanys();
    this.$tools.getall(data => {
      this.all = data;
      this.getTypeMap();
    });
  },
  methods: {
    /**
     * 打开上传产品补充协议弹窗
     */
    openAgreementModal() {
      this.$refs.agreementListModal.open();
    },

    /**
     * 处理补充协议提交事件
     * @param {Array} data - 协议列表数据
     */
    handleAgreementSubmit(data) {
      console.log('提交的协议数据:', data);
      // TODO: 调用后端接口保存协议数据
      this.$message.success('协议信息已提交');
    },

    // 结算函下载
    download(item) {
      location.href = '/master/means/balanceConfirmDownload?balanceId=' + item.id;
    },
    // 跳转上传提现资料
    jumpWait() {
      this.activeName2 = 'second';
      this.handleClick(1);
    },
    // 获取结算类型字典
    getTypeMap() {
      const map = this.all.BALANCE_TYPE;
      if (this.level != 1 && this.isXbbSecondMechan != 1) {
        // 不是1级且不是新保保 删除活动选项
        delete map['3'];
      }
      this.typeMap = map;
    },
    // 分公司列表
    getSubCompanys() {
      this.$http({
        url: '/master/content/querySubCompanys',
        type: 'put',
        params: {}
      }).then(res => {
        this.subCompanysList = res.data;
      });
    },
    // 跳转待生效列表
    goWaitList() {
      this.$router.push('/waitSettlement?isOpenSecond=' + this.isOpenSecond);
    },
    getUserInfo() {
      let url;
      if (this.accpimtType == 1) {
        //企业
        url = '/master/mechan/read/enterprise/detail';
      } else {
        //个人
        url = '/master/mechan/read/individual/detail';
      }
      this.$http({
        url: url,
        type: 'get'
      }).then(res => {
        this.status = res.data.auditStatus;
      });
    },
    xyflage: function() {
      this.$router.push('/costAgreement');
    },
    queryMechanInfo: function() {
      this.$http({
        url: '/master/mechan/queryMechanInfo',
        type: 'put',
        params: {}
      }).then(data => {
        this.mechanUserType = data.data.mechanUserType; //1机构2个人
        this.isOpenSecond = data.data.isOpenSecond;
      });
    },
    changeradio: function() {
      this.radio = !this.radio;
    },
    getCashPostal() {
      //提现状态
      var that = this;
      this.$http({
        url: '/master/means/getCashPostal',
        type: 'put',
        params: {}
      }).then(function(data) {
        that.cashStatus = data.data.cashStatus;
      });
    },
    changeDate() {
      //时间选择事件
      if (this.activeName2 == 'first') {
        this.readListFun(1); //查询业绩
        this.readCurrent = 1;
      } else {
        this.tabsFun(1); //提现记录
        this.tabsCurrent = 1;
      }
    },
    readDetail(row) {
      //收益明细查看详情
      this.$router.push({
        path: '/settlementDetail',
        query: {
          detailId: row.id,
          text: row.balanceDate,
          policyType: row.policyType,
          activityType: row.activityType,
          type: row.type
        }
      });
    },
    checkMeans() {
      //业绩核对
      var that = this;
      this.$http({
        url: '/master/means/info',
        type: 'put',
        params: {}
      }).then(function(data) {
        that.meansData = data.data;
      });
    },
    tabsFun(num) {
      //结算记录
      const params = {
        pageNum: num,
        pageSize: 10,
        cashStatus: this.type2
      };
      // 申请日期
      if (this.dateType2 == '1' && this.date && this.date.length == 2) {
        params.createTimeStart = this.date[0];
        params.createTimeEnd = this.date[1];
      }
      // 发放日期
      if (this.dateType2 == '2' && this.date && this.date.length == 2) {
        params.checkTimeStart = this.date[0];
        params.checkTimeEnd = this.date[1];
      }
      if (this.activeName2 == 'second') {
        if (this.activeName3 == '1') {
          params.cashStatusIn = [5];
        } else if (this.activeName3 == '2') {
          params.cashStatusIn = [1, 2, 3, 4, 6];
        }
      }
      this.pageLoading = true;
      this.$http({
        url: '/master/means/list/cashPostal',
        type: 'put',
        params: params
      })
        .then(data => {
          this.tableData = data.data;
          this.totalPage = data.total;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    updateMeans() {
      //结算
      // if (this.meansData.validCashPostal < 100) {
      //   return this.$message.error('提现金额需大于或等于100元！');
      // }
      if (this.mechanUserType == 2 || this.mechanUserType == 3) {
        //个人
        if (this.radio) {
          this.$refs.withdrawalNumberModal.open();
        } else {
          return this.$message.error('请勾选服务协议');
        }
      } else if (this.level == 2 || this.level == 1) {
        //1级、2级企业
        this.$refs.withdrawalNumberModal.open();
      }
    },
    // 撤销提现
    delWithdraw(row) {
      this.$confirm('确定撤销提现？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/master/means/delWaitUploadWithdraw?cashPostalId=' + row.id,
          type: 'delete',
          params: {}
        }).then(res => {
          this.reload();
          this.$message.success('操作成功');
        });
      });
    },
    // 刷新页面数据
    reload(successFlage) {
      if (successFlage) {
        this.successFlage = true;
      }
      this.tabsCurrent = 1;
      this.cashStatus = 2; //更新
      this.checkMeans(); //余额数据更新
      this.tabsFun(1); //提现记录更新
    },
    readListFun(num) {
      //业绩查询
      var params = {
        pageNum: num,
        pageSize: 10,
        asc: false,
        type: this.type,
        policyType: this.policyType,
        subCompanyId: this.subCompanyId,
        cashStatus: this.type2,
        orderBy: 'id'
      };
      // 按月
      if (this.dateType == '1' && this.monthDate) {
        params.balanceDate = this.monthDate;
      }
      // 按年
      if (this.dateType == '2' && this.yearDate) {
        params.balanceYear = this.yearDate;
      }
      this.pageLoading = true;
      this.$http({
        url: '/master/content/balance/list',
        type: 'put',
        params: params
      })
        .then(data => {
          this.curType = this.type;
          this.readListData = data.data;
          this.readtotalPage = data.total;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    handleClick(tabLevel) {
      this.$tools.cancelhttpRequest();
      this.tableData = [];
      if (tabLevel == 1) {
        if (this.mechanUserType == 1 && this.level == 1) {
          this.activeName3 = '1';
        } else {
          this.activeName3 = '2';
        }
      }
      if (this.activeName2 == 'first') {
        this.readListFun(1);
        this.readCurrent = 1;
      } else {
        this.tabsFun(1);
        this.tabsCurrent = 1;
      }
    },
    // 跳转提现记录
    jumpWithdraw() {
      this.activeName2 = 'second';
      this.activeName3 = '1';
      this.tabsCurrent = 1;
      this.tabsFun(1);
    },

    // 批量下载结算函
    downloadFile(item) {
      this.$tools.daochu('/master/means/balanceConfirmDownload', {
        cashPostalId: item.id
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './finance_m';
</style>
